import { z } from "zod";
//#region src/api/orpc/shared/id.ts
/**
* nanoId identifier schema — BigInt-coerced and must be positive.
*
* Canonical home for the schema; `pixai-server/src/api/orpc/utils/id.ts`
* re-exports from here so contract surfaces and server route handlers
* stay aligned without forcing consumers of the contract package to
* reach into server-internal utilities.
*/
const nanoIdSchema = z.coerce.bigint().positive();
//#endregion
export { nanoIdSchema };
